export const prepareHashNotificationText = (hashName: string) => {
  const hash = hashName.toUpperCase();
  return `${hash} ${hash !== "IMPHASH" ? "hash" : ""}`;
};
